import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { CheckCircle, ServerCrash } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { api, ApiError } from '@/lib/axios'

async function executeAuth(authId: string) {
  return api.backend.get(`/application-auth/execute-auth/${authId}`)
}

export function useExecuteAuth() {
  const { t } = useTranslation('sso')

  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    string
  >({
    mutationKey: ['/application-auth/execute-auth'],
    mutationFn: executeAuth,
    onSuccess: () => {
      toast(Toast, {
        data: {
          type: 'success',
          icon: CheckCircle,
          title: t(
            'applications.drawer_manage_auth.execute_auth.toast_success.title',
          ),
          description: t(
            'applications.drawer_manage_auth.execute_auth.toast_success.description',
          ),
        },
      })
    },
    onError: (error) => {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: ServerCrash,
          title: t(
            'applications.drawer_manage_auth.execute_auth.toast_error.title',
          ),
          description:
            error?.response?.data?.friendlyMessage ||
            t(
              'applications.drawer_manage_auth.execute_auth.toast_error.description',
            ),
        },
      })
    },
  })

  const handleExecuteAuth = async (authId: string) => {
    return mutateAsync(authId)
  }

  return {
    handleExecuteAuth,
    isExecutingAuth: isPending,
  }
}
